import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { PAGES } from '../../constants/pages';
import {
  ACCOUNT_TYPE_IRA_ROTH,
  ACCOUNT_TYPE_IRA_TRADITIONAL,
  APPLICATION_TYPE_IRA,
} from '../../constants/accountTypes';
import SelectList from '../../components/SelectList/SelectList';
import BaseLayout from '../../components/BaseLayout';
import { Heading } from '../../components/Heading';
import { applicationTypeSetupSuccess } from '../../store/actions/application/applicationActions';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const CreateApplicationRetirementPersonal = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { BrokerName } = useSelector(selectSettings);

  const options = [
    {
      title: t(
        'selectPath.options.retirement.owner.personalType.traditional.title',
      ),
      list: [
        {
          text: t(
            'selectPath.options.retirement.owner.personalType.traditional.taxDefer',
          ),
        },
        {
          text: t(
            'selectPath.options.retirement.owner.personalType.traditional.easyFund',
          ),
        },
        {
          text: t(
            'selectPath.options.retirement.owner.personalType.traditional.usOnly',
          ),
          fontWeight: 600,
        },
      ],
      onClick: () => {
        dispatch(
          applicationTypeSetupSuccess({
            ApplicationType: APPLICATION_TYPE_IRA,
            AccountType: ACCOUNT_TYPE_IRA_TRADITIONAL,
          }),
        );

        history.push(PAGES.CREATE_ACCOUNT);
      },
    },
    {
      title: t('selectPath.options.retirement.owner.personalType.roth.title'),
      list: [
        {
          text: t(
            'selectPath.options.retirement.owner.personalType.roth.taxFree',
          ),
        },
        {
          text: t(
            'selectPath.options.retirement.owner.personalType.roth.easyFund',
          ),
        },
        {
          text: t(
            'selectPath.options.retirement.owner.personalType.roth.usOnly',
          ),
          fontWeight: 600,
        },
      ],
      onClick: () => {
        dispatch(
          applicationTypeSetupSuccess({
            ApplicationType: APPLICATION_TYPE_IRA,
            AccountType: ACCOUNT_TYPE_IRA_ROTH,
          }),
        );

        history.push(PAGES.CREATE_ACCOUNT);
      },
      showDivider: false,
    },
  ];

  return (
    <BaseLayout
      previousPath={PAGES.CREATE_APPLICATION.RETIREMENT.MAIN}
      canShowEmail={false}
    >
      <Helmet>
        <title>
          {t('selectPath.options.retirement.owner.titleTag', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={28}>
        {t('selectPath.options.retirement.owner.titlePersonal')}
      </Heading>
      <SelectList options={options} />
    </BaseLayout>
  );
};

export default CreateApplicationRetirementPersonal;
